<template>
  <b-modal id="saveQuickPick"
           title = "Save as Quick Pick"
           :ok-only="step==='success'"
           :lazy="true"
           :ok-title = "okTitle"
           :ok-disabled = "loading"
           size="lg"
           @hidden = "hidden"
           @show="showDemo"
           @ok="save">
    <div v-if="step === 'input'">
    <b-row >
      <b-col class="the-box" cols="3">My Quickpick Name: (*)</b-col>
      <b-col class="input-box" cols="3">
        <b-input v-model ="quickPickName"></b-input>
        <m-error-text :val="quickPickName" :immediate="showError" :rules="['require']"/>
      </b-col>
      <b-col class="the-box" cols="3">My Quickpick Definition: (*)</b-col>
      <b-col class="input-box" cols="3">
        <b-input v-model ="quickPickDesc"></b-input>
        <m-error-text :val="quickPickDesc" :immediate="showError" :rules="['require']"/>
      </b-col>
    </b-row>
    <b-row class="m-text-deep selectrow">
      <b-col md="5">
        <h4 class="mt-2">Your Target Audience</h4>
        <b-select v-model = "unSelectedDemos"
                  :select-size="20"
                  class="demo-select"
                  multiple >
          <option v-for="item in selectedDemos"
                  :value="item" :class="{'demos-column':item.type === 'column' }" class="demos-value">
            {{item.AttributeValueName}}
          </option>
        </b-select>
      </b-col>
      <b-col md="2" class="m-select-btn-box">
        <b-btn class="m-select-btn"
               size="sm"
               @click="addDemos()">
          Add</b-btn>
        <b-btn class="m-select-btn"
               size="sm"
               @click="deleteDemos()">
          Remove</b-btn>
        <b-btn class="m-select-btn"
               @click="cleanDemos()"
               size="sm">
          Remove All</b-btn>
      </b-col>
      <b-col md="5">
        <h4 class="mt-2">Your Target Audience</h4>
        <b-select v-model = "unSaveDemos"
                  :select-size="20"
                  class="demo-select"
                  multiple>
          <option v-for="item in saveDemos"
                  :value="item" :class="{'demos-column':item.type === 'column' }" class="demos-value">
            {{item.AttributeValueName}}
          </option>
        </b-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert :show="alertDesc!==''"
                 variant="warning"
                 v-html="alertDesc"
                 style="margin-top: 8px"></b-alert>
      </b-col>
    </b-row>
    </div>
    <div v-if="step === 'success'">
    <b-row>
      <b-col>
          Your quickpick has been saved and is available moving forward behind the QuickPicks tab
      </b-col>
    </b-row>
    </div>
  </b-modal>

</template>

<script>
  import MErrorText from '@/components/common/MerrorText'
  import utlis from '@/assets/utils/index'
  import _ from 'lodash'

  export default {
    components: {
      MErrorText
    },
    created () {
    },
    data () {
      return {
        okTitle: 'save',
        step: 'input',
        quickPickDesc: '',
        quickPickName: '',
        alertDesc: '',
        loading: false,
        showError: false,
        unSelectedDemos: [],
        saveDemos: [],
        unSaveDemos: []
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      listType () {
        return this.$store.state.order.ListType
      },
      demos () {
        let result = []
        for (let demo of this.saveDemos) {
          if (demo.type === 'column') {
            result.push({
              Values: _.filter(this.saveDemos, x => { return x.ColumnName === demo.ColumnName && x.type === 'value' }),
              AttributeName: demo.AttributeValueName,
              ColumnName: demo.ColumnName,
              DemoCategoryType: demo.DemoCategoryType
            })
          }
        }
        return result
      },
      selectedDemos () {
        let demos = this.$store.getters['order/demoItems']
        let result = []
        for (let column of demos) {
          // when save qp, we should remove the selected qp options
          if (column.DemoCategoryType === 2) continue
          result.push({
            type: 'column',
            ColumnName: column.ColumnName,
            AttributeValueName: column.AttributeName,
            AttributeName: column.AttributeName,
            DemoCategoryType: column.DemoCategoryType
          })
          for (let value of column.Values) {
            result.push({
              type: 'value',
              AttributeValue: value.AttributeValue,
              ColumnName: value.ColumnName,
              AttributeValueName: value.AttributeValueName,
              AttributeName: column.AttributeName,
              DemoCategoryType: column.DemoCategoryType,
              ShortSeq: 5
            })
          }
        }
        return result
      }
    },
    methods: {
      save (evt) {
        this.alertDesc = ''
        if (this.step === 'input') {
          evt.preventDefault()
        } else {
          return
        }
        if (this.demos.length === 0) {
          this.alertDesc = 'Please add quickpick criteria.'
          return
        }
        this.showError = true
        let existError = false
        if (utlis.verify(this.quickPickDesc, 'require')) existError = true
        if (utlis.verify(this.quickPickName, 'require')) existError = true
        if (existError) return

        this.loading = true
        this.$http.post('PlaceOrder.aspx/SaveMyQuickpick', {
          listType: this.listType,
          quickPickDesc: this.quickPickDesc,
          quickPickName: this.quickPickName,
          targetOptions: this.demos
        }, {
          errorType: 'custom'
        }).then(resp => {
          this.step = 'success'
          this.title = 'Thank your'
          this.okTitle = 'Close'
          this.loading = false
          this.quickPickName = ''
          this.quickPickDesc = ''
          this.$store.commit('demo/saveKey', ['saveNewQuickPick', true])
          this.$store.commit('demo/saveKey', ['hasQuickPicks', true])
        }, resp => {
          this.loading = false
          this.alertDesc = resp.body.d.ResultMessage
        })
      },
      hidden () {
        this.step = 'input'
        this.okTitle = 'Save'
      },
      showDemo () {
        this.saveDemos = JSON.parse(JSON.stringify(this.selectedDemos))
      },
      cleanDemos () {
        this.saveDemos = []
      },
      deleteDemos () {
        let tempDemos = JSON.parse(JSON.stringify(this.saveDemos))
        for (let item of this.unSaveDemos) {
          if (item.type === 'value') {
            _.remove(tempDemos, x => { return x.ColumnName === item.ColumnName && x.AttributeValue === item.AttributeValue })
            if (_.findIndex(tempDemos, x => { return x.ColumnName === item.ColumnName && x.type === 'value' }) < 0) {
              _.remove(tempDemos, x => { return x.ColumnName === item.ColumnName })
            }
          } else {
            _.remove(tempDemos, x => { return x.ColumnName === item.ColumnName })
          }
        }
        this.saveDemos = tempDemos
      },
      addDemos () {
        let tempDemos = JSON.parse(JSON.stringify(this.saveDemos))
        for (let item of this.unSelectedDemos) {
          if (item.type === 'value') {
            if (_.findIndex(tempDemos,
                x => { return x.ColumnName === item.ColumnName && x.AttributeValue === item.AttributeValue && x.AttributeName === item.AttributeName }) < 0) {
              let colIndex = _.findIndex(tempDemos, x => { return x.ColumnName === item.ColumnName && x.type === 'column' && x.AttributeName === item.AttributeName })
              if (colIndex < 0) {
                tempDemos.push(this.selectedDemos[_.findIndex(this.selectedDemos, x => { return x.ColumnName === item.ColumnName && x.type === 'column' && x.AttributeName === item.AttributeName })])
                tempDemos.push(item)
              } else {
                tempDemos.splice(colIndex + 1, 0, item)
              }
            }
          } else {
            let values = _.filter(this.selectedDemos,
              x => { return x.ColumnName === item.ColumnName && x.type === 'value' && x.AttributeName === item.AttributeName })
            let colIndex = _.findIndex(tempDemos, x => { return x.ColumnName === item.ColumnName && x.type === 'column' && x.AttributeName === item.AttributeName })
            if (colIndex < 0) {
              tempDemos.push(item)
              for (let v of values) {
                tempDemos.push(v)
              }
            } else {
              for (let v of values) {
                if (_.findIndex(tempDemos,
                    x => { return x.ColumnName === v.ColumnName && x.AttributeValue === v.AttributeValue && x.AttributeName === item.AttributeName }) < 0) {
                  tempDemos.splice(colIndex + 1, 0, v)
                }
              }
            }
          }
        }
        this.saveDemos = tempDemos
      }
    }
  }
</script>

<style scoped lang="scss">
.the-box {
  display: flex;
  align-items: center;
  font-size:14px;
  padding-right: 8px;
  padding-left: 16px;
  padding-top: 0;
}
  .input-box{
    padding-left:0px;
    text-align: left;
  }
  .selectrow{
    margin-top: 15px;
  }
.demos-column.demos-value {
  color: $color-black;
  margin-left: 0; /* TODO@PONY no unifrom css */
  font-size: 0.9em;
}
.demos-value {
  margin-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/demo/MSaveQuickPick.vue